<template>
  <div id="app">
    {{ stateSync }}
    <router-view />
  </div>
</template>

<script>
import { checkAndSetAccess, ensureGuestUUID } from "@/utils/helpers";
export default {
  name: "App",
  computed: {
    stateSync() {
      let stt = this.$store.state;
      localStorage.setItem("simpAdminState", JSON.stringify(stt));
      return "";
    },
  },
  created() {
    // Initialize guest UUID for anonymous user tracking
    // This ensures every visitor has a unique identity for tracking search history
    const hasAccess = this.$store.getters["userVUEX/getCandAccess"];
    if(!hasAccess){
      ensureGuestUUID();
    }
    // Restore Vuex state
    let savedstate = localStorage.getItem("simpAdminState");
    if (savedstate != null) {
      const mergedState = Object.assign(
        {},
        this.$store.state,
        JSON.parse(savedstate),
      );
      this.$store.replaceState(mergedState);
    }
    checkAndSetAccess();
  },
  watch: {
    $route(to) {
      this.updateCanonicalLink(to);
    },
  },
  mounted() {
    this.updateCanonicalLink(this.$route);

    // Listen for Back-Forward Cache (BFCache) restorations
    this._globalPageShowHandler = (event) => {
      if (event.persisted) {
        // Force a hard refresh to ensure clean state when returning from another project
        window.location.reload();
      }
    };
    window.addEventListener("pageshow", this._globalPageShowHandler);
  },
  beforeDestroy() {
    window.removeEventListener("pageshow", this._globalPageShowHandler);
  },
  methods: {
    updateCanonicalLink(route) {
      const baseUrl = "https://www.hire3x.com"; // 👈 replace with your domain
      const path = route.path.replace(/\/$/, ""); // remove trailing slash if any
      const canonicalUrl = baseUrl + path;

      let link = document.querySelector("link[rel='canonical']");
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonicalUrl);
    },
  },
};
</script>

<style scoped>
#app {
  height: 100vh;
}

@media screen and (max-width: 1028px) {
  #app {
    height: 100dvh;
  }
}
</style>
